<template>

    <div class="input-group w-auto">

        <input class="form-control" 
               autocomplete="off" 
               type="search" 
               name="search" 
               :placeholder="placeholder" 
               :value="value"
               @input="$emit('input', $event.target.value)" />

        <slot />

        <!--        <button class="btn btn-secondary" 
                        type="button" 
                        @click="$emit('reset')">
                    {{ __('Reset') }}
                </button>-->

    </div>

</template>

<script>
    export default {
        props: {
            value: String,
            placeholder: {
                default: 'Suche',
                type: String
            }
        },
    }
</script>